export const labelCanvasRectProps = (
  id: string,
  left: number,
  top: number,
  width: number,
  height: number,
  color: string,
  fill: string,
  cornerRadius: number,
  strokeDashArray?: number[]
): fabric.IRectOptions => {
  return {
    type: "rect",
    name: id,
    originX: "center",
    originY: "center",
    stroke: color,
    strokeWidth: 1,
    left: left,
    top: top,
    width: width,
    height: height,
    rx: cornerRadius,
    ry: cornerRadius,
    fill: fill,
    selectable: false,
    evented: false,
    strokeDashArray: strokeDashArray,
  };
};

export const labelCanvasCircleProps = (
  id: string,
  left: number,
  top: number,
  radius: number,
  color: string,
  fill: string,
  strokeDashArray?: number[]
): fabric.ICircleOptions => {
  return {
    type: "circle",
    name: id,
    originX: "center",
    originY: "center",
    stroke: color,
    strokeWidth: 1,
    left: left,
    top: top,
    radius: radius,
    fill: fill,
    selectable: false,
    evented: false,
    strokeDashArray: strokeDashArray,
  };
};

export const labelCanvasLineProps = (
  id: string,
  color: string,
  strokeDashArray?: number[]
): fabric.ILineOptions => {
  return {
    type: "line",
    name: id,
    originX: "center",
    originY: "center",
    stroke: color,
    strokeWidth: 1,
    selectable: false,
    evented: false,
    strokeDashArray: strokeDashArray,
  };
};
